import type { Milli } from './qty'

/** The fields of a stock_movements row that stock math needs. */
export interface MovementLike {
  product_id: string
  location_id: string
  qty_milli: Milli
  deleted_at?: string | null
}

export interface StockLevel {
  product_id: string
  location_id: string
  qty_milli: Milli
}

export type StockStatus = 'out_of_stock' | 'low_stock' | 'in_stock'

/** Current stock per product and location, derived from the movement ledger. */
export function stockLevels(movements: Iterable<MovementLike>): StockLevel[] {
  const levels = new Map<string, StockLevel>()
  for (const m of movements) {
    if (m.deleted_at) continue
    const key = `${m.product_id}|${m.location_id}`
    const level = levels.get(key)
    if (level) level.qty_milli += m.qty_milli
    else
      levels.set(key, {
        product_id: m.product_id,
        location_id: m.location_id,
        qty_milli: m.qty_milli,
      })
  }
  return [...levels.values()]
}

/** Same thresholds the old inventory-desk current_stock view used. */
export function stockStatus(qtyMilli: Milli, minStockMilli: Milli): StockStatus {
  if (qtyMilli <= 0) return 'out_of_stock'
  if (qtyMilli <= minStockMilli) return 'low_stock'
  return 'in_stock'
}
